var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
    for (var name in all) __defProp(target, name, {
      get: all[name],
      enumerable: !0
    });
  },
  __copyProps = (to, from, except, desc) => {
    if (from && typeof from == "object" || typeof from == "function") for (let key of __getOwnPropNames(from)) !__hasOwnProp.call(to, key) && key !== except && __defProp(to, key, {
      get: () => from[key],
      enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable
    });
    return to;
  };
var __toCommonJS = mod => __copyProps(__defProp({}, "__esModule", {
  value: !0
}), mod);
var useTheme_exports = {};
__export(useTheme_exports, {
  activeThemeManagers: () => activeThemeManagers,
  getThemeManager: () => getThemeManager,
  useChangeThemeEffect: () => useChangeThemeEffect,
  useTheme: () => useTheme,
  useThemeWithState: () => useThemeWithState
});
module.exports = __toCommonJS(useTheme_exports);
var import_constants = require("@tamagui/constants"),
  import_react = require("react"),
  import_config = require("../config.cjs"),
  import_createVariable = require("../createVariable.cjs"),
  import_ThemeManager = require("../helpers/ThemeManager.cjs"),
  import_ThemeManagerContext = require("../helpers/ThemeManagerContext.cjs"),
  import_createShallowSetState = require("../helpers/createShallowSetState.cjs"),
  import_shouldDeoptDueToParentScheme = require("./shouldDeoptDueToParentScheme.cjs");
const emptyProps = {
    name: null
  },
  useTheme = (props = emptyProps) => {
    const [_, theme] = useThemeWithState(props);
    return theme;
  },
  useThemeWithState = props => {
    const keys = (0, import_react.useRef)(null),
      changedThemeState = useChangeThemeEffect(props, !1, keys);
    process.env.NODE_ENV === "development" && globalThis.time && time`theme-change-effect`;
    const {
      themeManager,
      state
    } = changedThemeState;
    process.env.NODE_ENV === "development" && (state?.theme || process.env.TAMAGUI_DISABLE_NO_THEME_WARNING !== "1" && console.error(`[tamagui] No theme found, this could be due to an invalid theme name (given theme props ${JSON.stringify(props)}).

If this is intended and you are using Tamagui without any themes, you can disable this warning by setting the environment variable TAMAGUI_DISABLE_NO_THEME_WARNING=1`));
    const themeProxied = getThemeProxied(props, state, keys, themeManager);
    return process.env.NODE_ENV === "development" && props.debug === "verbose" && (console.groupCollapsed(`  \u{1F539} [${themeManager?.id}] useTheme =>`, state?.name), console.info("returning state", changedThemeState.state, changedThemeState.isNewTheme, "from props", props), console.groupEnd()), [changedThemeState, themeProxied];
  },
  emptyObject = {},
  ProxiedThemes = /* @__PURE__ */new Map();
let curKeys, curProps, curThemeManger;
function getThemeProxied(_props, state, _keys, _themeManager) {
  const theme = state?.theme;
  if (!theme || !_themeManager) return emptyObject;
  if (curKeys = _keys, curProps = _props, curThemeManger = _themeManager, ProxiedThemes.has(theme)) return ProxiedThemes.get(theme);
  const {
      name,
      scheme
    } = state,
    config = (0, import_config.getConfig)();
  function track(key) {
    curKeys && (curKeys.current || (curKeys.current = []), curKeys.current.push(key), process.env.NODE_ENV === "development" && curProps.debug && console.info(` \u{1F3A8} useTheme() tracking new key: ${key}`));
  }
  const proxied = Object.fromEntries(Object.entries(theme).flatMap(([key, value]) => {
    const proxied2 = {
      ...value,
      get val() {
        return globalThis.tamaguiAvoidTracking || track(key), value.val;
      },
      get(platform) {
        return (0, import_createVariable.getVariable)(value);
      }
    };
    return [[key, proxied2], [`$${key}`, proxied2]];
  }));
  return ProxiedThemes.set(theme, proxied), proxied;
}
const activeThemeManagers = /* @__PURE__ */new Set(),
  _uidToManager = /* @__PURE__ */new WeakMap(),
  _idToUID = {},
  getId = id => _idToUID[id],
  getThemeManager = id => _uidToManager.get(getId(id)),
  registerThemeManager = t => {
    if (!_idToUID[t.id]) {
      const id = _idToUID[t.id] = {};
      _uidToManager.set(id, t);
    }
  },
  ogLog = console.error,
  preventWarnSetState = process.env.NODE_ENV === "production" ? ogLog :
  // temporary fix for logs, they are harmless in that i've tried to rewrite this
  // a few times using the "right" ways, but they are always slower. maybe skill issue
  (a, ...args) => {
    if (!(typeof a == "string" && a.includes("Cannot update a component"))) return ogLog(a, ...args);
  };
function getShouldUpdateTheme(props, parentManager, keys, themeState, nextState, forceShouldChange = !1) {
  if (import_constants.isServer || !forceShouldChange && !keys?.current && (!themeState || !themeState.isNewTheme) && !(0, import_ThemeManager.getHasThemeUpdatingProps)(props)) return;
  const next = nextState || themeState?.themeManager?.getState(props, parentManager);
  if (forceShouldChange) return next;
  if (!(!next || next.theme === themeState?.state?.theme)) return next;
}
const useChangeThemeEffect = (props, isRoot = !1, keys) => {
  const {
      disable
    } = props,
    parentManager = (0, import_react.useContext)(import_ThemeManagerContext.ThemeManagerContext),
    shouldAlwaysUpdate = props.needsUpdate?.() === !0 ? !0 : void 0;
  if (!isRoot && !parentManager || disable) return {
    isNewTheme: !1,
    state: parentManager?.state,
    themeManager: parentManager
  };
  const [themeState, setThemeState] = (0, import_react.useState)(createState),
    {
      state,
      mounted,
      isNewTheme,
      themeManager,
      prevState
    } = themeState,
    isInversingOnMount = !!(!themeState.mounted && props.inverse);
  if (import_constants.isServer || ((0, import_react.useLayoutEffect)(() => {
    themeManager && state && prevState && state !== prevState && themeManager.notify();
  }, [state]), (0, import_react.useEffect)(() => {
    if (!themeManager) return;
    if (props.inverse && !mounted) {
      setThemeState(prev => createState({
        ...prev,
        mounted: !0
      }));
      return;
    }
    (isNewTheme || isRoot) && (activeThemeManagers.add(themeManager), process.env.NODE_ENV === "development" && isRoot && (globalThis.TamaguiRootThemeManager ||= themeManager));
    const updated = getShouldUpdateTheme(props, parentManager, keys, themeState, void 0, shouldAlwaysUpdate);
    updated && setThemeState(prev => createState(prev, void 0, updated));
    const selfListenerDispose = themeManager.onChangeTheme((_a, _b, forced) => {
        forced && setThemeState(prev => createState(prev, forced !== "self"));
      }, !0),
      disposeChangeListener = parentManager?.onChangeTheme((name, manager, forced) => {
        const force = forced || (import_constants.isServer ? void 0 : keys?.current ? !0 : void 0) || props.deopt || void 0,
          shouldTryUpdate = force ?? !!(keys?.current || isNewTheme);
        process.env.NODE_ENV === "development" && props.debug === "verbose" && console.info(" \u{1F538} onChange", {
          id: themeManager.id,
          force,
          shouldTryUpdate,
          props,
          name,
          keys
        }), shouldTryUpdate && setThemeState(prev => createState(prev, !0));
      }, themeManager.id);
    return () => {
      selfListenerDispose(), disposeChangeListener?.(), isNewTheme && activeThemeManagers.delete(themeManager);
    };
  }, [themeManager, parentManager, isNewTheme, props.componentName, props.inverse, props.name, props.reset, mounted]), process.env.NODE_ENV === "development" && props.debug !== "profile" && (0, import_react.useEffect)(() => (globalThis.TamaguiThemeManagers ??= /* @__PURE__ */new Set(), globalThis.TamaguiThemeManagers.add(themeManager), () => {
    globalThis.TamaguiThemeManagers.delete(themeManager);
  }), [themeManager])), import_constants.isWeb && isInversingOnMount) return {
    isNewTheme: !1,
    inversed: !1,
    themeManager: parentManager,
    state: {
      name: "",
      ...parentManager?.state,
      className: ""
    }
  };
  return {
    state,
    isNewTheme,
    inversed: !!props.inverse,
    themeManager
  };
  function createState(prev, force = !1, foundNextState) {
    if (prev && !foundNextState && !keys?.current && !force) return prev;
    let themeManager2 = parentManager,
      state2;
    if ((0, import_ThemeManager.getHasThemeUpdatingProps)(props)) {
      const parentManagerProp = isRoot ? "root" : parentManager;
      if (prev?.themeManager) {
        themeManager2 = prev.themeManager;
        const forceChange = force || shouldAlwaysUpdate || (keys?.current ? !0 : void 0);
        let nextState = null;
        if (foundNextState) nextState = foundNextState;else {
          const next = themeManager2.getState(props, parentManager);
          nextState = getShouldUpdateTheme(props, parentManager, keys, prev, next, forceChange);
        }
        nextState ? (state2 = nextState, !prev.isNewTheme && !isRoot ? themeManager2 = new import_ThemeManager.ThemeManager(props, parentManagerProp) : themeManager2.updateState(nextState)) : prev.isNewTheme && parentManager && !nextState && (themeManager2 = parentManager);
      } else themeManager2 = new import_ThemeManager.ThemeManager(props, parentManagerProp), state2 = {
        ...themeManager2.state
      };
    }
    const isNewTheme2 = !!(themeManager2 !== parentManager || props.inverse);
    isNewTheme2 && registerThemeManager(themeManager2);
    const mounted2 = (import_constants.isWeb ? !(0, import_config.getSetting)("disableSSR") : !1) ? isRoot || prev?.mounted : !0;
    state2 || (isNewTheme2 ? state2 = themeManager2.state : (state2 = parentManager.state, themeManager2 = parentManager));
    const response = {
      themeManager: themeManager2,
      isNewTheme: isNewTheme2,
      mounted: mounted2
    };
    props.inverse && (response.inversed = !0);
    const shouldReturnPrev = prev && !force &&
    // isEqualShallow uses the second arg as the keys so this should compare without state first...
    (0, import_createShallowSetState.isEqualShallow)(prev, response) &&
    // ... and then compare just the state, because we make a new state obj but is likely the same
    (0, import_createShallowSetState.isEqualShallow)(prev.state, state2);
    if (prev && shouldReturnPrev) return prev;
    if (response.state = state2, response.prevState = prev?.state, process.env.NODE_ENV === "development" && props.debug && import_constants.isClient) {
      console.groupCollapsed(`\u{1F537} [${themeManager2.id}] useChangeThemeEffect createState`);
      const parentState = {
          ...parentManager?.state
        },
        parentId = parentManager?.id,
        themeManagerState = {
          ...themeManager2.state
        };
      console.info({
        props,
        parentState,
        parentId,
        themeManager: themeManager2,
        prev,
        response,
        themeManagerState
      }), console.groupEnd();
    }
    return response;
  }
};